export default "__VITE_ASSET__BfJE14RF__"